export const DEFAULT_CLIP_START_MILLIS = 0;
export const DEFAULT_CLIP_END_MILLIS = 60000;
export const DEFAULT_PREPARING_CLIP_TAB_MESSAGE = 'Preparing your clip…';
